import { render, staticRenderFns } from "./CompanySolution.vue?vue&type=template&id=48d904d0"
import script from "./CompanySolution.vue?vue&type=script&lang=js"
export * from "./CompanySolution.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports